import axios from '@/vendor/axios';

export default {
  sendReferrals(referrals) {
    return axios.post('referrals', { referrals })
      .then(response => response.data);
  },
};
